import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = Math.random().toString(36).substr(2, 9);
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  const removeToast = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast-container">
        {toasts.map((toast) => (
          <div key={toast.id} className={`toast toast-${toast.type}`} onClick={() => removeToast(toast.id)}>
            {toast.message}
          </div>
        ))}
      </div>
      <style>{`
        .toast-container {
          position: fixed;
          top: 24px;
          right: 24px;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .toast {
          min-width: 220px;
          background: #222;
          color: #fff;
          padding: 14px 22px;
          border-radius: 8px;
          box-shadow: 0 4px 24px rgba(0,0,0,0.13);
          font-size: 1.05em;
          cursor: pointer;
          opacity: 0.97;
          transition: background 0.18s, color 0.18s;
        }
        .toast-success { background: #22c55e; color: #fff; }
        .toast-error { background: #ef4444; color: #fff; }
        .toast-info { background: #2563eb; color: #fff; }
        .toast-warning { background: #f59e42; color: #fff; }
      `}</style>
    </ToastContext.Provider>
  );
};
